import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class EnableSecondMapCreateJobsite implements IFlagFeature {
  name: string = Features.ENABLED_SECOND_MAP_CREATE_JOBSITE;

  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
